import styled from 'styled-components';
import theme from 'styles/theme';

export const PropertiesBodyListStyled = styled.ul.attrs({
  'data-testid': 'properties-body',
})<{ $isChildPropertiesContainer?: boolean }>`
  background-color: white;
  flex: 1;
  list-style-type: none;
  margin: ${({ $isChildPropertiesContainer }) =>
    $isChildPropertiesContainer ? '0 -15px -15px' : '0'};
  padding: 0;

  .infinite-scroll-component__outerdiv {
    height: 100%;

    .infinite-scroll-component {
      height: 100% !important;
    }
  }
`;

export const PropertiesCountContainer = styled.div.attrs({
  'data-testid': 'properties-count-showing',
})`
  display: flex;
  justify-content: end;
  color: ${theme.colors.gray600};
  margin-top: -16px;
  margin-bottom: 16px;
`;
